import PropTypes from 'prop-types';
import { getAssistantBubbleClasses } from '../../utils/ai/chatTheme';

const LoadingIndicator = ({ label = 'Analyzing metrics...', theme = 'dark' }) => (
  <div className={`rounded-[10px] px-3.5 py-2.5 text-sm shadow-sm ${getAssistantBubbleClasses(theme)}`}>
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-1.5" aria-hidden="true">
        <span
          className={`h-2 w-2 rounded-full animate-bounce [animation-delay:-0.2s] ${
            theme === 'dark' ? 'bg-[#48A7FF]' : 'bg-[#066FD1]'
          }`}
        />
        <span
          className={`h-2 w-2 rounded-full animate-bounce [animation-delay:-0.1s] ${
            theme === 'dark' ? 'bg-[#48A7FF]' : 'bg-[#066FD1]'
          }`}
        />
        <span
          className={`h-2 w-2 rounded-full animate-bounce ${
            theme === 'dark' ? 'bg-[#48A7FF]' : 'bg-[#066FD1]'
          }`}
        />
      </div>
      <span className="font-medium">{label}</span>
    </div>
  </div>
);

LoadingIndicator.propTypes = {
  label: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
};

export default LoadingIndicator;
